// Aviso no topo do offcanvas do item (SPEC 2026-10-20 §10.2): títulos anulados na Ampli que
// tiravam valor deste item da EAP. Entrada: o `annulled[]` da resposta de fornecedores (já
// carregado no offcanvas; por obra, sem filtro de EAP) e o `wbs_code_id` do item. Um título
// conta quando algum dos seus `wbsCodes` é o próprio item, um ancestral ou um descendente
// (prefixo do código da EAP). Valores em REAIS.
// Não usar <span> para o texto: o reset de _fonts.scss zera todo span dentro de .card.

const brl = (value) => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const related = (code, itemCode) => code.startsWith(itemCode) || itemCode.startsWith(code);

export const matchingAnnulledTitles = (annulled, wbsCode) => {
  const itemCode = String(wbsCode ?? "");
  if (!itemCode || !Array.isArray(annulled)) return [];
  return annulled.filter((title) => (Array.isArray(title?.wbsCodes) ? title.wbsCodes : [])
    .some((code) => code != null && String(code) !== "" && related(String(code), itemCode)));
};

export const itemNoticeText = (titles) => {
  const total = titles.reduce((sum, title) => sum + (Number(title.removedToPay) || 0), 0);
  return `Este item tem ${titles.length} título(s) anulado(s) na Ampli · ${brl(total)} fora da conta`;
};

const ItemAnnulmentNotice = ({ annulled, wbsCode }) => {
  const titles = matchingAnnulledTitles(annulled, wbsCode);
  if (!titles.length) return null;
  return <p className="title-annulment-notice card-label margin-bottom-16" role="note">{itemNoticeText(titles)}</p>;
};

export default ItemAnnulmentNotice;
